import { BaseEntity } from './base-entity.model';
import { Company } from './company.model';

export abstract class CatalogueEntity extends BaseEntity {
    producer?: Company;
    svtCode: string;
}
